(function (window, document) {
  'use strict';

  if (window.GrapheneResults) { return; }

  var SELECTOR = '[data-graphene-results]';
  /* Keep the Query API payload limited to fields the OMNES product card actually
     renders. Advanced Commerce reads this allow-list from
     response_options.requested_fields; facets and pagination metadata are returned
     separately from each result item. */
  var REQUESTED_PRODUCT_FIELDS = [
    'id',
    'titles',
    'slug',
    'url',
    'canonical_url',
    'min_pricing',
    'max_pricing',
    'media',
    'variants'
  ];
  var PRODUCT_MEDIA_REQUESTS = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function titleOf(value, fallback) {
    if (value && typeof value === 'object') {
      return value.default || value['en-gb'] || value.en || fallback || '';
    }
    return value || fallback || '';
  }

  function activeCurrency(root) {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return root.dataset.currency || 'GBP';
  }

  function activeMarket(root) {
    try {
      if (window.Shopify && window.Shopify.country) { return window.Shopify.country; }
    } catch (e) {}
    return root.dataset.market || activeCurrency(root);
  }

  function activeLanguage(root) {
    var language = '';

    try {
      if (window.Shopify && window.Shopify.locale) { language = window.Shopify.locale; }
    } catch (e) {}

    language = language || root.dataset.language || 'en-gb';
    return language.toLowerCase() === 'en' ? 'en-gb' : language.toLowerCase();
  }

  function searchQuery(root) {
    var query = root.dataset.query || '';
    var params;

    if (query) { return query; }

    try {
      params = new URLSearchParams(window.location.search);
      query = params.get('q') || params.get('search_text') || '';
    } catch (e) {}

    root.dataset.query = query;
    return query;
  }

  function moneyFormatter(currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      });
    } catch (e) {
      return { format: function (amount) { return (currency || 'GBP') + ' ' + Number(amount || 0).toFixed(2); } };
    }
  }

  function requestArgs(page) {
    var args = {};
    var params;

    try { params = new URLSearchParams(window.location.search); }
    catch (e) { params = null; }

    if (params) {
      params.forEach(function (value, key) {
        if (key === 'q' || key === 'page') { return; }
        if (Object.prototype.hasOwnProperty.call(args, key)) {
          if (!Array.isArray(args[key])) { args[key] = [args[key]]; }
          args[key].push(value);
        } else {
          args[key] = value;
        }
      });
    }

    if (page > 1) { args.pg = String(page); }
    else { delete args.pg; }

    return args;
  }

  function currentPage() {
    var page = 1;
    try { page = Number(new URLSearchParams(window.location.search).get('pg') || 1); }
    catch (e) {}
    return page > 0 && isFinite(page) ? page : 1;
  }

  function facetTitle(facet) {
    var labels = {
      'shopify_dress-occasion': 'Occasion',
      'shopify_skirt-dress-length-type': 'Dress length'
    };
    return labels[facet.id] || titleOf(facet.titles, facet.id);
  }

  function facetInputId(root, facet, item, index) {
    return ((root.id || 'graphene-results') + '-' + facet.id + '-' + (item.id || index))
      .replace(/[^a-zA-Z0-9_-]/g, '-');
  }

  function facetItems(facet) {
    var items = Array.isArray(facet.items) ? facet.items.slice() : [];
    var sizeOrder = {
      'XXS': 100,
      'XS': 110,
      'S': 120,
      'M': 130,
      'L': 140,
      'XL': 150,
      'XXL': 160,
      '3XL': 170,
      '4XL': 180,
      'ONE SIZE': 190
    };

    if (facet.id !== 'size' && facet.id !== 'shopify_size') { return items; }

    return items.sort(function (left, right) {
      var leftTitle = String(titleOf(left.titles, left.id)).trim().toUpperCase();
      var rightTitle = String(titleOf(right.titles, right.id)).trim().toUpperCase();
      var leftNumber = /^\d+$/.test(leftTitle) ? Number(leftTitle) : null;
      var rightNumber = /^\d+$/.test(rightTitle) ? Number(rightTitle) : null;

      if (leftNumber !== null && rightNumber !== null) { return leftNumber - rightNumber; }
      if (leftNumber !== null) { return -1; }
      if (rightNumber !== null) { return 1; }

      return (sizeOrder[leftTitle] || 999) - (sizeOrder[rightTitle] || 999) ||
        leftTitle.localeCompare(rightTitle);
    });
  }

  function facetMarkup(root, facet) {
    var items = facetItems(facet);
    var type = facet.select_type === 'single' ? 'radio' : 'checkbox';
    var title = facetTitle(facet);
    var selectedCount = items.filter(function (item) { return item.selected; }).length;

    if (!items.length) { return ''; }

    return '<details class="filters__section graphene-results__facet" data-graphene-facet-group="' +
      escapeHtml(facet.id) + '"' + (selectedCount ? ' open' : '') + '><summary class="graphene-results__facet-summary">' +
      '<span>' + escapeHtml(title) + '</span>' + (selectedCount ? '<span class="graphene-results__facet-selected">' +
      selectedCount + ' selected</span>' : '') + '</summary><div class="graphene-results__facet-options" role="group" aria-label="' +
      escapeHtml(title) + '">' + items.map(function (item, index) {
        var id = facetInputId(root, facet, item, index);
        var disabled = Number(item.count || 0) === 0 && !item.selected;
        return '<input type="' + type + '" class="btn-check" name="' + escapeHtml(facet.id) +
          '" value="' + escapeHtml(item.id) + '" id="' + escapeHtml(id) + '" data-graphene-facet' +
          (item.selected ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
          '<label class="btn btn-outline-primary" for="' + escapeHtml(id) + '">' +
          escapeHtml(titleOf(item.titles, item.id)) +
          '<span class="graphene-results__facet-count">' + escapeHtml(item.count || 0) + '</span></label>';
      }).join('') + '</div></details>';
  }

  function chipsMarkup(facets) {
    var chips = [];

    facets.forEach(function (facet) {
      (facet.items || []).forEach(function (item) {
        if (!item.selected) { return; }
        chips.push('<button type="button" class="graphene-results__chip" data-graphene-remove-facet="' +
          escapeHtml(facet.id) + '" data-graphene-remove-value="' + escapeHtml(item.id) +
          '" aria-label="Remove ' + escapeHtml(titleOf(item.titles, item.id)) + ' filter"><span>' +
          escapeHtml(titleOf(item.titles, item.id)) + '</span></button>');
      });
    });

    return chips.join('');
  }

  function layoutMarkup(root) {
    var columns = String(root.dataset.columns || '6');
    return '<div class="product-grid__layout"><p>View By</p><div class="btn-group" role="group" aria-label="Products per row">' +
      '<button type="button" class="dark-button d-lg-none' + (columns === '1' ? ' select' : '') +
      '" data-graphene-columns="1">1</button>' +
      '<button type="button" class="dark-button d-lg-none' + (columns === '2' ? ' select' : '') +
      '" data-graphene-columns="2">2</button>' +
      '<button type="button" class="dark-button d-none d-lg-block' + (columns === '3' ? ' select' : '') +
      '" data-graphene-columns="3">3</button>' +
      '<button type="button" class="dark-button d-none d-lg-block' + (columns === '4' ? ' select' : '') +
      '" data-graphene-columns="4">4</button>' +
      '<button type="button" class="dark-button d-none d-lg-block' + (columns === '6' ? ' select' : '') +
      '" data-graphene-columns="6">6</button></div></div>';
  }

  function activeSort() {
    var value = '';

    try { value = new URLSearchParams(window.location.search).get('sort_by') || ''; }
    catch (e) {}

    return value === 'price-ascending' || value === 'price-descending' ? value : '';
  }

  function sortMarkup(root) {
    var selected = activeSort();

    return '<label class="graphene-results__sort"><span>Sort by</span><select data-graphene-sort ' +
      'aria-label="Sort products"><option value=""' + (!selected ? ' selected' : '') + '>Featured</option>' +
      '<option value="price-ascending"' + (selected === 'price-ascending' ? ' selected' : '') +
      '>Price, low to high</option><option value="price-descending"' +
      (selected === 'price-descending' ? ' selected' : '') + '>Price, high to low</option></select></label>';
  }

  function settingsMarkup(root, products, countText) {
    var facets = Array.isArray(products.facets) ? products.facets : [];
    var drawerId = (root.id || 'graphene-results') + '-filters';
    var labelId = drawerId + '-label';
    var chips = chipsMarkup(facets);
    var filterControl = '';

    if (facets.length) {
      filterControl = '<button type="button" class="dark-button small-button graphene-results__filter-button' +
        (chips ? ' graphene-results__filter-button--active' : '') + '" data-bs-toggle="offcanvas" data-bs-target="#' +
        escapeHtml(drawerId) + '" aria-controls="' + escapeHtml(drawerId) + '">Filter</button>' +
        '<div class="' + (chips ? 'chips' : 'graphene-results__chips-empty') +
        '" data-graphene-chips>' + chips + '</div>' +
        '<div class="offcanvas offcanvas-start graphene-results__filters" tabindex="-1" id="' +
        escapeHtml(drawerId) + '" data-bs-scroll="false" data-bs-backdrop="true" aria-labelledby="' +
        escapeHtml(labelId) + '"><div class="offcanvas-header"><p class="dark-button small-button" id="' +
        escapeHtml(labelId) + '">Filter</p><button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>' +
        (chips ? '<div class="chips">' + chips + '</div>' : '') + '</div><div class="offcanvas-body">' +
        facets.map(function (facet) { return facetMarkup(root, facet); }).join('') +
        '</div><div class="offcanvas-footer"><button type="button" class="dark-button" data-graphene-apply>Apply filters</button>' +
        '</div></div>';
    }

    return '<div class="row g-0"><div class="col-12 d-flex align-items-center"><div class="product-grid__settings graphene-results__settings">' +
      filterControl + '<p class="graphene-results__count" data-graphene-status aria-live="polite">' +
      escapeHtml(countText) + '</p>' + sortMarkup(root) + layoutMarkup(root) + '</div></div></div>';
  }

  function updateSortUrl(value) {
    var url;

    try { url = new URL(window.location.href); }
    catch (e) { return false; }

    if (value === 'price-ascending' || value === 'price-descending') {
      url.searchParams.set('sort_by', value);
    } else {
      url.searchParams.delete('sort_by');
    }
    url.searchParams.delete('pg');
    url.searchParams.delete('page');
    window.history.pushState(null, '', url.pathname + url.search + url.hash);
    return true;
  }

  function updateFacetUrl(root) {
    var url;
    var groups = root.querySelectorAll('[data-graphene-facet-group]');

    try { url = new URL(window.location.href); }
    catch (e) { return false; }

    Array.prototype.forEach.call(groups, function (group) {
      var key = group.getAttribute('data-graphene-facet-group');
      var selected = group.querySelectorAll('[data-graphene-facet]:checked');
      url.searchParams.delete(key);
      Array.prototype.forEach.call(selected, function (input) {
        url.searchParams.append(key, input.value);
      });
    });
    url.searchParams.delete('pg');
    url.searchParams.delete('page');
    window.history.pushState(null, '', url.pathname + url.search + url.hash);
    return true;
  }

  function removeFacetValue(key, value) {
    var url;
    var values;

    try { url = new URL(window.location.href); }
    catch (e) { return false; }

    values = url.searchParams.getAll(key).filter(function (item) { return item !== value; });
    url.searchParams.delete(key);
    values.forEach(function (item) { url.searchParams.append(key, item); });
    url.searchParams.delete('pg');
    url.searchParams.delete('page');
    window.history.pushState(null, '', url.pathname + url.search + url.hash);
    return true;
  }

  function closeDrawer(drawer, callback) {
    var completed = false;
    var instance;

    function done() {
      if (completed) { return; }
      completed = true;
      callback();
    }

    if (drawer && window.bootstrap && window.bootstrap.Offcanvas) {
      drawer.addEventListener('hidden.bs.offcanvas', done, { once: true });
      window.setTimeout(done, 350);
      try {
        instance = window.bootstrap.Offcanvas.getOrCreateInstance(drawer);
        instance.hide();
      } catch (error) {
        done();
      }
      return;
    }
    done();
  }

  function bindDrawerState(root) {
    var drawer = root.querySelector('.graphene-results__filters');
    if (!drawer) { return; }

    drawer.addEventListener('show.bs.offcanvas', function () {
      document.body.classList.add('offcanvas-filters-visible');
    });
    drawer.addEventListener('hidden.bs.offcanvas', function () {
      document.body.classList.remove('offcanvas-filters-visible');
    });
  }

  function setPageUrl(page) {
    var url;

    try {
      url = new URL(window.location.href);
      if (page > 1) { url.searchParams.set('pg', String(page)); }
      else { url.searchParams.delete('pg'); }
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      return true;
    } catch (e) {
      return false;
    }
  }

  function orderedMedia(item) {
    var media = item && item.media;
    if (!media || typeof media !== 'object') { return []; }

    return Object.keys(media).map(function (key) { return media[key]; })
      .filter(function (entry) { return entry && mediaSource(entry); })
      .sort(function (a, b) { return Number(a.sequence || 0) - Number(b.sequence || 0); });
  }

  function mediaSource(entry) {
    return entry && (entry.src || entry.url) || '';
  }

  function isVideoMedia(entry) {
    var source = String(mediaSource(entry)).toLowerCase();
    var type = String(entry && (entry.media_type || entry.type || entry.mime_type || entry.format) || '').toLowerCase();

    return type.indexOf('video') !== -1 || type.indexOf('mpegurl') !== -1 ||
      /\.(m3u8|mp4|webm)(?:$|[?#])/.test(source);
  }

  function productJsonUrl(item) {
    var path = String(item && (item.url || item.canonical_url) || '');
    var match;

    try { path = new URL(path, window.location.origin).pathname; }
    catch (e) {}

    match = path.match(/\/products\/([^/?#]+)/);
    if (!match && item && item.slug) { match = [null, item.slug]; }
    return match ? '/products/' + match[1] + '.js' : '';
  }

  function preferredMp4(video) {
    var sources = video && Array.isArray(video.sources) ? video.sources.filter(function (source) {
      return source && source.url && (source.format === 'mp4' || source.mime_type === 'video/mp4' || /\.mp4(?:$|[?#])/.test(source.url));
    }) : [];

    sources.sort(function (left, right) { return Number(left.height || 0) - Number(right.height || 0); });
    return sources.filter(function (source) { return Number(source.height || 0) >= 720; })[0] || sources[sources.length - 1] || null;
  }

  function videoMarkup(source, poster, title) {
    return '<video class="product-item__video" autoplay loop muted playsinline preload="metadata"' +
      (poster ? ' poster="' + escapeHtml(poster) + '"' : '') + ' aria-label="' + escapeHtml(title) + '">' +
      '<source src="' + escapeHtml(source.url) + '" type="' + escapeHtml(source.mime_type || 'video/mp4') + '">' +
      '</video>';
  }

  function requestProductMedia(url) {
    if (!PRODUCT_MEDIA_REQUESTS[url]) {
      PRODUCT_MEDIA_REQUESTS[url] = window.fetch(url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) { throw new Error('Shopify product media request failed'); }
        return response.json();
      });
    }
    return PRODUCT_MEDIA_REQUESTS[url];
  }

  function hydrateProductVideos(root) {
    if (!window.fetch) { return; }

    Array.prototype.forEach.call(root.querySelectorAll('[data-graphene-video-card]'), function (link) {
      var jsonUrl = link.getAttribute('data-product-json');
      var title = link.getAttribute('data-product-title') || '';
      var fallbackPoster = link.getAttribute('data-video-poster') || '';

      if (!jsonUrl || link.getAttribute('data-graphene-video-state')) { return; }
      link.setAttribute('data-graphene-video-state', 'loading');

      requestProductMedia(jsonUrl).then(function (product) {
        var video = Array.isArray(product.media) ? product.media.filter(function (entry) {
          return entry && entry.media_type === 'video';
        })[0] : null;
        var source = preferredMp4(video);
        var poster = video && video.preview_image && video.preview_image.src || fallbackPoster;

        if (!source) { throw new Error('Shopify product has no MP4 source'); }
        if (!document.documentElement.contains(link)) { return; }

        link.innerHTML = videoMarkup(source, poster, title);
        link.setAttribute('data-graphene-video-state', 'ready');
      }).catch(function () {
        link.setAttribute('data-graphene-video-state', 'unavailable');
      });
    });
  }

  function variantGroups(item) {
    var variants = item && item.variants;
    if (!variants || typeof variants !== 'object') { return []; }

    return Object.keys(variants).map(function (key) {
      var group = variants[key] || {};
      var options = group.options || {};
      return {
        id: key,
        title: titleOf(group.definition && group.definition.titles, key),
        options: Object.keys(options).map(function (optionKey) {
          var option = options[optionKey] || {};
          return {
            id: option.id,
            title: titleOf(option.definition && option.definition.titles, optionKey),
            available: option.available_for_sale === true
          };
        })
      };
    }).filter(function (group) { return group.options.length; });
  }

  function saleBadge(item, root, formatter) {
    var pricing = item.min_pricing || {};
    var price = Number(pricing.price || 0);
    var was = Number(pricing.was || pricing.rrp || 0);
    var mode = root.dataset.saleMode;

    if (!was || was <= price || mode === 'disabled') { return ''; }

    var saving = mode === 'percentages'
      ? Math.round(((was - price) / was) * 100) + ' %'
      : formatter.format(was - price);
    var style = '';
    if (root.dataset.saleBackground) { style += 'background:' + root.dataset.saleBackground + ';'; }
    if (root.dataset.saleText) { style += 'color:' + root.dataset.saleText + ';'; }

    return '<div class="tag"><span style="' + escapeHtml(style) + '">' +
      escapeHtml(root.dataset.saveLabel || 'Save') + ' ' + escapeHtml(saving) + '</span></div>';
  }

  function imageMarkup(item, title) {
    var media = orderedMedia(item);
    if (!media.length) { return ''; }

    var primary = media[0];
    var images = media.filter(function (entry) { return !isVideoMedia(entry); });
    var primaryImage = isVideoMedia(primary) ? images[0] : primary;
    var secondary = images.filter(function (entry) { return entry !== primaryImage; })[0];
    var link = escapeHtml(item.url || item.canonical_url || '#');
    var jsonUrl = productJsonUrl(item);
    var html;

    if (isVideoMedia(primary) && jsonUrl) {
      html = '<a href="' + link + '" data-graphene-video-card data-product-json="' + escapeHtml(jsonUrl) +
        '" data-product-title="' + escapeHtml(title) + '" data-video-poster="' +
        escapeHtml(mediaSource(primaryImage)) + '">';
    } else {
      html = '<a href="' + link + '">';
    }

    if (primaryImage) {
      html += '<img src="' + escapeHtml(mediaSource(primaryImage)) + '" alt="' + escapeHtml(title) +
        '" width="' + escapeHtml(primaryImage.width || 800) + '" height="' +
        escapeHtml(primaryImage.height || 1067) + '" loading="lazy">';
    }

    if (secondary) {
      html += '<span class="product-item__image-hover"><img src="' + escapeHtml(mediaSource(secondary)) +
        '" alt="" width="' + escapeHtml(secondary.width || 800) + '" height="' +
        escapeHtml(secondary.height || 1067) + '" loading="lazy"></span>';
    }

    return html + '</a>';
  }

  function variantMarkup(groups) {
    if (!groups.length) { return ''; }

    return '<div class="product-item__variable">' + groups.map(function (group) {
      return '<div class="variable variable-' + escapeHtml(group.id) + '">' +
        '<button type="button" class="btn-close d-lg-none variable-close bound-event-002" aria-label="Close"></button>' +
        '<p><span class="d-lg-none">Select</span> ' + escapeHtml(group.title) + ' :</p>' +
        '<ul class="nav ms-auto">' + group.options.map(function (option, index) {
          var disabled = option.available ? '' : ' disabled';
          return '<li class="nav-item bound-event-004"><button type="button" class="nav-link' + disabled +
            (index < group.options.length - 1 ? ' me-1' : '') + '" data-graphene-variant="' +
            escapeHtml(option.id || '') + '"' + (option.available ? '' : ' disabled aria-disabled="true"') + '>' +
            escapeHtml(option.title) + '</button></li>';
        }).join('') + '</ul></div>';
    }).join('') + '</div>';
  }

  function productCard(result, root, formatter, clickCode) {
    var item = result && result.item ? result.item : {};
    var title = titleOf(item.titles, item.slug || 'Product');
    var url = escapeHtml(item.url || item.canonical_url || '#');
    var price = Number((item.min_pricing && item.min_pricing.price) || 0);
    var maxPrice = Number((item.max_pricing && item.max_pricing.price) || price);
    var was = Number((item.min_pricing && (item.min_pricing.was || item.min_pricing.rrp)) || 0);
    var groups = variantGroups(item);
    var pricePrefix = maxPrice > price ? (root.dataset.fromLabel || 'From') + ' ' : '';
    var oldPrice = was > price ? '<p class="old-price">' + escapeHtml(formatter.format(was)) + '</p>' : '';
    var addButton = groups.length
      ? '<button type="button" class="add-to-bag d-lg-none bound-event-001" aria-label="' +
        escapeHtml((root.dataset.selectLabel || 'Select options for') + ' ' + title) + '">' +
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<path d="M2.34189 18H15.6581C16.9494 18 18 16.9197 18 15.592V4.99331C18 4.71572 17.7821 4.49164 17.5121 4.49164H13.2056V4.29097C13.2056 1.92308 11.3321 0 9.03253 0C6.73292 0 4.85942 1.92642 4.85942 4.29097V4.49164H0.487893C0.217926 4.49164 0 4.71572 0 4.99331V15.5886C0 16.9197 1.0506 18 2.34189 18ZM5.83195 4.29431C5.83195 2.48161 7.26635 1.00669 9.02927 1.00669C10.7922 1.00669 12.2266 2.48161 12.2266 4.29431V4.49498H5.83195V4.29431ZM0.975786 5.49498H4.85616C4.85616 5.47157 5.36682 5.49498 5.36682 5.49498C5.63679 5.49498 5.83195 5.49498 5.83195 5.49498H12.2299C12.2299 5.49498 12.4153 5.49498 12.6852 5.49498H13.2056H17.0242V15.5886C17.0242 16.3645 16.4127 16.9933 15.6581 16.9933H2.34189C1.58728 16.9933 0.975786 16.3612 0.975786 15.5886Z" fill="currentColor"></path>' +
        '</svg></button>'
      : '';

    return '<article class="product-item bound-event-003" data-product_id="' + escapeHtml(item.id || '') +
      '" data-handle="' + escapeHtml((item.properties && item.properties.handle) || item.slug || '') + '"' +
      (clickCode ? ' data-acs-cc="' + escapeHtml(clickCode) + '"' : '') + '>' +
      '<div class="product-item__content"><div class="product-item__content__image">' + addButton +
      saleBadge(item, root, formatter) + '<div class="product-item__image">' + imageMarkup(item, title) +
      '</div></div><div class="product-item__info' + (was > price ? ' have-sale' : '') + '">' +
      '<div class="product-item__info-top"><div class="product-item__name"><h3><a href="' + url + '">' +
      escapeHtml(title) + '</a></h3></div><div class="product-item__price">' + oldPrice + '<p>' +
      escapeHtml(pricePrefix + formatter.format(price)) + '</p></div></div></div>' + variantMarkup(groups) +
      '</div></article>';
  }

  function productPayload(response, template) {
    var element = response && response.elements && response.elements[template];
    return element && element.products ? element.products : null;
  }

  function validResponse(response, template, query) {
    if (!response || !response.header || Number(response.header.status) !== 200) { return false; }
    if (!productPayload(response, template)) { return false; }
    if (template === 'category' && !response.header.category_id) { return false; }
    if (template === 'search' && query && String(response.header.search_text || '').toLowerCase() !== query.toLowerCase()) {
      return false;
    }
    return true;
  }

  function announce(root, message) {
    var status = root.querySelector('[data-graphene-status]');
    if (status) { status.textContent = message; }
  }

  function usesInfiniteScroll() {
    return document.body.getAttribute('data-plp-pagination-style') === 'infinite_scroll';
  }

  function disconnectInfiniteScroll(root) {
    if (!root._grapheneInfiniteScrollObserver) { return; }
    root._grapheneInfiniteScrollObserver.disconnect();
    root._grapheneInfiniteScrollObserver = null;
  }

  function revealLoadMoreFallback(root) {
    var button = root.querySelector('[data-graphene-more]');
    var wrap = button && button.parentNode;

    disconnectInfiniteScroll(root);
    if (!button || !wrap || wrap.hidden) { return; }
    button.hidden = false;
    wrap.classList.remove('graphene-results__more--infinite');
  }

  function observeInfiniteScroll(root, graphenehc) {
    var button = root.querySelector('[data-graphene-more]');
    var wrap = button && button.parentNode;

    disconnectInfiniteScroll(root);
    if (!button || !wrap || wrap.hidden || !usesInfiniteScroll()) { return; }
    if (!('IntersectionObserver' in window)) {
      revealLoadMoreFallback(root);
      return;
    }

    button.hidden = true;
    wrap.classList.add('graphene-results__more--infinite');
    root._grapheneInfiniteScrollObserver = new IntersectionObserver(function (entries) {
      var shouldLoad = entries.some(function (entry) { return entry.isIntersecting; });
      if (!shouldLoad || button.disabled || root.getAttribute('aria-busy') === 'true') { return; }

      root._grapheneInfiniteScrollObserver.unobserve(wrap);
      button.disabled = true;
      requestPage(root, graphenehc, Number(button.dataset.nextPage || 2), true);
    }, { root: null, rootMargin: '400px 0px', threshold: 0 });
    root._grapheneInfiniteScrollObserver.observe(wrap);
  }

  function renderShell(root, products, response) {
    var meta = products.meta || {};
    var count = Number(meta.product_count == null ? meta.count : meta.product_count) || 0;
    var formatter = moneyFormatter(response.header.currency || activeCurrency(root), response.header.language_culture);
    var cards = (products.results || []).map(function (result) {
      return productCard(result, root, formatter, meta.click_code);
    }).join('');
    var columns = escapeHtml(root.dataset.columns || '6');
    var hasNext = Number(meta.current_page || 1) < Number(meta.page_count || 1);
    var countText = count + ' ' + (count === 1 ? (root.dataset.productLabel || 'product') : (root.dataset.productsLabel || 'products'));

    disconnectInfiniteScroll(root);
    root.innerHTML = '<div class="product-grid"><div class="container-fluid p-0">' + settingsMarkup(root, products, countText) +
      '<div class="row g-0"><div class="col-md-12"><div class="product-grid__default columns-' + columns +
      '" data-graphene-grid>' + (cards || '<div class="graphene-results__empty text-center fw-bold my-5 fs-2">' +
      escapeHtml(root.dataset.emptyLabel || 'No products found') + '</div>') + '</div>' +
      '<div class="shp-load-more-wrap graphene-results__more text-center py-4"' + (hasNext ? '' : ' hidden') + '>' +
      '<button type="button" class="dark-button" data-graphene-more data-next-page="' +
      escapeHtml(Number(meta.current_page || 1) + 1) + '">' + escapeHtml(root.dataset.loadMoreLabel || 'Load more') +
      '</button></div></div></div></div></div>';

    bindDrawerState(root);
    hydrateProductVideos(root);

    if (products.meta && products.meta.click_code) {
      root.dataset.acsCc = products.meta.click_code;
    }
  }

  function appendPage(root, products, response) {
    var grid = root.querySelector('[data-graphene-grid]');
    var button = root.querySelector('[data-graphene-more]');
    var wrap = button && button.parentNode;
    var meta = products.meta || {};
    var formatter = moneyFormatter(response.header.currency || activeCurrency(root), response.header.language_culture);

    if (!grid || !button) { return; }

    grid.insertAdjacentHTML('beforeend', (products.results || []).map(function (result) {
      return productCard(result, root, formatter, meta.click_code);
    }).join(''));
    hydrateProductVideos(grid);

    button.dataset.nextPage = String(Number(meta.current_page || 1) + 1);
    button.disabled = false;
    root.removeAttribute('aria-busy');
    if (Number(meta.current_page || 1) >= Number(meta.page_count || 1)) { wrap.hidden = true; }
    announce(root, (meta.to || '') + ' of ' + (meta.product_count || meta.count || '') + ' products loaded');
  }

  function queryOptions(root, page) {
    var template = root.dataset.template;
    var pageContext = {
      currency_id: activeMarket(root),
      language_id: activeLanguage(root)
    };
    var options = {
      format: 'json',
      template: { id: template },
      page_context: pageContext,
      args: requestArgs(page),
      response_options: {
        requested_fields: REQUESTED_PRODUCT_FIELDS.slice()
      }
    };

    if (template === 'search') { options.search_text = searchQuery(root); }
    if (template === 'category') {
      pageContext.category_id = root.dataset.collectionHandle || '';
      options.shopify = {
        collection_id: root.dataset.collectionId || '',
        collection_handle: root.dataset.collectionHandle || ''
      };
    }

    return options;
  }

  function requestPage(root, graphenehc, page, append) {
    var template = root.dataset.template;
    var query = template === 'search' ? searchQuery(root) : '';
    var previousUrl = window.location.href;
    var pageUrlChanged = false;

    if (template === 'search' && !query) { return; }

    /* GrapheneHC derives pagination from x_page_url, which json() always sets from
       window.location.href. Update the visible pg value before requesting another
       page; args.pg alone is ignored by the category/search endpoint. */
    if (append) { pageUrlChanged = setPageUrl(page); }

    root.setAttribute('aria-busy', 'true');
    graphenehc.json(queryOptions(root, page)).then(function (response) {
      var products;
      var fallback;

      if (!validResponse(response, template, query)) {
        throw new Error(template === 'category' ? 'Advanced Commerce category is not mapped' : 'Unexpected response');
      }

      products = productPayload(response, template);
      if (!Array.isArray(products.results)) { throw new Error('Product results are missing'); }

      if (append) {
        appendPage(root, products, response);
        if (typeof graphenehc._persistClick === 'function') { graphenehc._persistClick(root); }
        observeInfiniteScroll(root, graphenehc);
        return;
      }

      renderShell(root, products, response);
      if (typeof graphenehc._persistClick === 'function') { graphenehc._persistClick(root); }
      fallback = root.parentNode && root.parentNode.querySelector('[data-graphene-fallback="' + template + '"]');
      if (fallback) { fallback.hidden = true; }
      root.hidden = false;
      root.removeAttribute('aria-busy');
      root.dataset.grapheneActive = 'true';
      observeInfiniteScroll(root, graphenehc);
    }).catch(function (error) {
      var button = root.querySelector('[data-graphene-more]');
      if (pageUrlChanged) {
        try { window.history.replaceState(null, '', previousUrl); } catch (e) {}
      }
      root.removeAttribute('aria-busy');
      if (button) { button.disabled = false; }
      if (append && usesInfiniteScroll()) { revealLoadMoreFallback(root); }
      if (window.console && window.console.warn) {
        window.console.warn('[GrapheneHC] ' + template + ' JSON unavailable — Shopify fallback retained', error);
      }
    });
  }

  function bindRoot(root, graphenehc) {
    if (root.dataset.grapheneBound === 'true') { return; }
    root.dataset.grapheneBound = 'true';

    root.addEventListener('change', function (event) {
      var sort = event.target.closest('[data-graphene-sort]');

      if (!sort) { return; }
      if (updateSortUrl(sort.value)) { requestPage(root, graphenehc, 1, false); }
    });

    root.addEventListener('click', function (event) {
      var more = event.target.closest('[data-graphene-more]');
      var add = event.target.closest('.add-to-bag');
      var close = event.target.closest('.variable-close');
      var variant = event.target.closest('[data-graphene-variant]');
      var apply = event.target.closest('[data-graphene-apply]');
      var remove = event.target.closest('[data-graphene-remove-facet]');
      var layout = event.target.closest('[data-graphene-columns]');
      var card;
      var proxy;

      if (apply) {
        event.preventDefault();
        closeDrawer(apply.closest('.graphene-results__filters'), function () {
          if (updateFacetUrl(root)) { requestPage(root, graphenehc, 1, false); }
        });
        return;
      }

      if (remove) {
        event.preventDefault();
        closeDrawer(remove.closest('.graphene-results__filters'), function () {
          if (removeFacetValue(remove.dataset.grapheneRemoveFacet, remove.dataset.grapheneRemoveValue)) {
            requestPage(root, graphenehc, 1, false);
          }
        });
        return;
      }

      if (layout) {
        event.preventDefault();
        root.dataset.columns = layout.dataset.grapheneColumns;
        Array.prototype.forEach.call(root.querySelectorAll('[data-graphene-grid]'), function (grid) {
          grid.className = grid.className.replace(/columns-\d+/g, 'columns-' + layout.dataset.grapheneColumns);
        });
        Array.prototype.forEach.call(root.querySelectorAll('[data-graphene-columns]'), function (button) {
          button.classList.toggle('select', button.dataset.grapheneColumns === layout.dataset.grapheneColumns);
        });
        return;
      }

      if (more) {
        event.preventDefault();
        more.disabled = true;
        requestPage(root, graphenehc, Number(more.dataset.nextPage || 2), true);
        return;
      }

      if (add) {
        event.preventDefault();
        add.closest('.product-item__content').classList.toggle('variable-show');
        return;
      }

      if (close) {
        event.preventDefault();
        close.closest('.product-item__content').classList.remove('variable-show');
        return;
      }

      if (!variant || variant.disabled) { return; }
      event.preventDefault();
      card = variant.closest('.product-item');
      proxy = card && card.querySelector('.add-to-bag');
      if (!proxy) {
        proxy = document.createElement('button');
        proxy.type = 'button';
        proxy.hidden = true;
        card.appendChild(proxy);
      }
      proxy.dataset.variant_id = variant.dataset.grapheneVariant;
      proxy.dataset.quantity = '1';
      if (window.shpCustom && typeof window.shpCustom.cartItemAdd === 'function') {
        window.shpCustom.cartItemAdd(proxy);
      }
    });

    window.addEventListener('popstate', function () {
      requestPage(root, graphenehc, currentPage(), false);
    });

    requestPage(root, graphenehc, currentPage(), false);
  }

  function init() {
    var roots = document.querySelectorAll(SELECTOR);
    var boot = window.GrapheneBoot;
    if (!roots.length || !boot) { return; }

    boot.ready(function (graphenehc) {
      if (!graphenehc || typeof graphenehc.json !== 'function') { return; }
      roots.forEach(function (root) { bindRoot(root, graphenehc); });
    });
  }

  window.GrapheneResults = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})(window, document);
